// Animationen (hauptsächlich Marquees) weglassen für development? (um den Lüfter zu schonen :-)
(window as any).NO_ANIMATIONS = false;

// Übersetzungsmodul initialisieren
const I18n = require('i18n-js');
I18n.defaultLocale = I18n.locale = document.documentElement.getAttribute('lang');
I18n.fallbacks = false;
I18n.translations = require('../locales');

// diverse Module und Variablen global verfügbar machen
// (wird von assets/js/main.js benötigt)
import $ from 'jquery';
(window as any).$ = (window as any).jQuery = $;
import {isPhone} from './useragent';
(window as any).IS_PHONE = isPhone;
import {thumbnailKeyFor, thumbnailUrlWithKeyFor, addLocaleToUrl} from './nutsandwoods';
(window as any).thumbnailKeyFor = thumbnailKeyFor;
(window as any).thumbnailUrlWithKeyFor = thumbnailUrlWithKeyFor;
(window as any).addLocaleToUrl = addLocaleToUrl;
import {formatPrice} from './i18n';
(window as any).formatPrice = formatPrice;
import {eventCheckoutSelectPaymentMethod, eventCheckoutSelectShippingMethod} from './matomo';
(window as any).eventCheckoutSelectPaymentMethod = eventCheckoutSelectPaymentMethod;
(window as any).eventCheckoutSelectShippingMethod = eventCheckoutSelectShippingMethod;
(async () => {
    type ReadyCallback = (YooconShopNamespace: typeof YooconShop) => void;
    const callbacks: Array<ReadyCallback> = [];
    (window as any).onYooconShopReady = (callback: ReadyCallback) => callbacks.push(callback);
    const {cart} = await import('./yoocon-shop');
    (window as any).CART = cart;
    (window as any).onYooconShopReady = (callback: ReadyCallback) => callback(YooconShop);
    callbacks.forEach(callback => callback(YooconShop));
})();

// unsere eigenen Module einbinden
require ('./layout');
require('./menu.ts');
require('./mouse-link');
import initializeHoverFlip from './hover-flip';
initializeHoverFlip();
require('./parts/footer');

// Komponenten einbinden
import CartIndicator from './components/Cart/Indicator.svelte';
const $header = $('body > header');
if($header.length) {
    new CartIndicator({
        target: $header[0],
    });
}
import NewsletterForm from './components/Newsletter/Form.svelte';
$('.newsletter-section').each(function() {
    new NewsletterForm({
        target: this,
    });
});

// auf Initialisierung warten
$(() => {
    // Module für Abschnitte und Komponenten
    const {subscribe} = require('./parts/newsletter');
    (window as any).subscribeToNewsletter = subscribe;
    require('./parts/discount-teaser');
    // seitenspezifische Module
    const $body = $('body');
    if($body.is('#page-home'))
        require('./pages/home');
    if($body.is('#page-about'))
        require('./pages/about');
    if($body.is('#page-checkout'))
        require('./pages/checkout');
    if($body.is('.products-single-page'))
        require('./pages/product');
    if($body.is('.page-journal'))
        require('./pages/journal');
    if($body.is('#page-service'))
        require('./pages/service');
    if($body.is('#page-category'))
        require('./pages/category');
    if($body.is('#page-limited-offers'))
        require('./pages/limited-offers');
});
